import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { LayoutType } from '../../../types/layouts.esm.js';
import { sameArray } from '../../../utilities/same-array.esm.js';
import { ActionTypes } from './action-types.esm.js';

function reducer(state, action) {
  var type = action.type;
  switch (action.type) {
    case ActionTypes.Initialize:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        layouts: action.layouts
      });
    case ActionTypes.Update:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        layouts: action.layouts
      });
    case ActionTypes.UpdateEntities:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        entities: action.entities
      });
    case ActionTypes.NewDefaultFields:
      {
        var _state$layouts, _state$layouts2;
        var defaultLayout = (_state$layouts = state.layouts) === null || _state$layouts === void 0 ? void 0 : _state$layouts.find(function (l) {
          return l.type === LayoutType.Default;
        });
        var rest = ((_state$layouts2 = state.layouts) === null || _state$layouts2 === void 0 ? void 0 : _state$layouts2.filter(function (l) {
          return l.type !== LayoutType.Default;
        })) || [];
        if (!defaultLayout) {
          return state;
        }
        if (sameArray(defaultLayout.fields, action.fields)) {
          return state;
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          layouts: [_objectSpread2(_objectSpread2({}, defaultLayout), {}, {
            fields: action.fields
          })].concat(_toConsumableArray(rest))
        });
      }
    default:
      throw new Error("Action type ".concat(type, " not supported."));
  }
}

export { reducer };
//# sourceMappingURL=reducer.esm.js.map
